import { BackendError } from './base';
import General from './general';

class InvalidStakeholderCredentials extends BackendError {}
class InvalidStakeholderToken extends BackendError {}
class StakeholderInviteAlreadyExists extends BackendError {}
class StakeholderDoesNotExist extends General.NotFound {}
class PersonNotFound extends General.NotFound {}

export default {
    InvalidStakeholderCredentials,
    InvalidStakeholderToken,
    StakeholderInviteAlreadyExists,
    StakeholderDoesNotExist,
    PersonNotFound,
};
